<h1>Invoice report</h1>
<ag-grid-angular class="ag-theme-quartz" style="height: 500px;"
[rowData]="rowData"
[columnDefs]="colDefs"
[columnDefs]="colDefs"
[defaultColDef]="defaultColDef"
[pagination]="true" [rowSelection]="'multiple'"
    (gridReady)="onGridReady($event)" (cellValueChanged)="onCellValueChanged($event)"
    (selectionChanged)="onSelectionChanged($event)">
</ag-grid-angular>